import { orderSource as appraisalOrderSource, AppraisalResult } from '../appraisal/index'

export const operType = [
  // { key: 20, value: '助理' },
  { key: 21, value: '图片审核' },
  { key: 22, value: '图片复审' },
  { key: 24, value: '图片终审' }
]

export const appraisalStatus = [
  { label: '全部', value: null },
  // { label: '待分配', value: 5 },
  { label: '图片审核', value: 3 },
  { label: '图片审核补图中', value: 9 },
  { label: '图片复审', value: 4 },
  { label: '图片复审补图中', value: 10 },
  { label: '图片终审', value: 7 },
  { label: '图片终审补图中', value: 13 },
  { label: '已完成', value: 15 },
  { label: '已过期', value: 16 }
]

export const appraisalResult = [
  ...AppraisalResult,
  { key: 25, value: '超时关单', source: [] }
]

export const orderSource = appraisalOrderSource

export const getStatusName = (val) => val ? (appraisalStatus.find((i) => i.value === val) || {}).label : '-'
export const getAppraisalResultName = (val, orderSource) => {
  const item = appraisalResult.find((i) => i.key === val) || {}
  return item['label' + orderSource] || item.value
}
export const getOrderSourceName = (val) => (orderSource.find((i) => i.value === val) || {}).label

export const getOperTypeName = (val) => (operType.find((i) => i.key === val) || {}).value

export const thirdpartySyncFail = [
  { label: '全部', value: null },
  { label: '推送失败', value: 1 }
]

export const reminderList = [
  { label: '全部', value: null },
  { label: '未催单', value: 0 },
  { label: '已催单', value: 1 }
]

export const processingTimeoutList = [
  { label: '全部', value: null },
  { label: '未超时', value: 0 },
  { label: '已超时', value: 1 }
]

export const isFirstAppraisalOrderList = [
  { label: '全部', value: null },
  { label: '首次鉴定', value: 1 },
  { label: '非首次鉴定', value: 0 }
]

export const ImageAppraisalerLevel = [
  { label: '普通', value: 1 },
  { label: '专家', value: 9 }
]

export const getImageAppraisalerLevelName = (val) => (ImageAppraisalerLevel.find((i) => i.value === val))?.label

export const ImageExpertFlag = [
  { label: '专家组', value: 1 },
  { label: '普通组', value: 0 }
]

export const getImageExpertFlagName = (val) => (ImageExpertFlag.find((i) => i.value === val))?.label
